export const KEYSFOBS_CREATE_EDIT_OPEN_MODAL = "KEYSFOBS_CREATE_EDIT_OPEN_MODAL";
export const KEYSFOBS_CREATE_REQUEST = "KEYSFOBS_CREATE_REQUEST";
export const KEYSFOBS_CREATE_RESULT = "KEYSFOBS_CREATE_RESULT";
export const KEYSFOBS_UPDATE_REQUEST = "KEYSFOBS_UPDATE_REQUEST";
export const KEYSFOBS_UPDATE_RESULT = "KEYSFOBS_UPDATE_RESULT";
export const KEYSFOBS_GET_KEYFOB_REQUEST = "KEYSFOBS_GET_KEYFOB_REQUEST";
export const KEYSFOBS_GET_KEYFOB_RESULT = "KEYSFOBS_GET_KEYFOB_RESULT";

export const KEYSFOBS_GET_DRIVER_REQUEST = "KEYSFOBS_GET_DRIVER_REQUEST";
export const KEYSFOBS_GET_DRIVER_RESULT = "KEYSFOBS_GET_DRIVER_RESULT";